var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("connection-settings-popup", {
    attrs: {
      "is-new": _vm.isNew,
      "comment-id": _vm.commentId,
      invalid: _vm.$v.$invalid,
      resources: {
        deletePromptTitle: _vm.resource(
          "JourneyBuilder_TimerSettings_Delete_Title"
        ),
        deletePromptBody: _vm.resource(
          "JourneyBuilder_TimerSettings_Delete_Body"
        )
      }
    },
    on: {
      save: function($event) {
        return _vm.save()
      },
      delete: function($event) {
        return _vm.deleteCheckpoint()
      },
      "display-errors": function($event) {
        return _vm.displayErrors()
      },
      hidden: function($event) {
        return _vm.$emit("hidden")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _c("h3", { staticClass: "d-inline-block" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.resource("JourneyBuilder_TimerSettings_Title")) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "h4",
              { staticClass: "mt-1 ml-1" },
              [
                _c("help-popover", {
                  attrs: {
                    title: _vm.resource("JourneyBuilder_TimerSettings_Title"),
                    content: _vm.resource(
                      "JourneyBuilder_TimerSettings_Description"
                    )
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c("div", { staticClass: "row form-group" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.resource("JourneyBuilder_TimerSettings_Body_Title")
                    )
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group" }, [
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("settings-property", {
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function(ref) {
                          var id = ref.id
                          return [
                            _c("label", { attrs: { for: id } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.resource(
                                    "JourneyBuilder_TimerSettings_ScheduleType_Label"
                                  )
                                )
                              )
                            ])
                          ]
                        }
                      },
                      {
                        key: "input",
                        fn: function(ref) {
                          var id = ref.id
                          return [
                            _c("v-select", {
                              staticClass: "form-control",
                              attrs: {
                                options: _vm.SCHEDULE_TYPE_OPTIONS,
                                disabled: !_vm.canWrite,
                                clearable: false,
                                "input-id": id,
                                searchable: "",
                                filterable: ""
                              },
                              model: {
                                value: _vm.scheduleTypeModel,
                                callback: function($$v) {
                                  _vm.scheduleTypeModel = $$v
                                },
                                expression: "scheduleTypeModel"
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "errors",
                        fn: function() {
                          return [
                            _vm.$v.$dirty && _vm.$v.scheduleType.$invalid
                              ? _c("required-error-message")
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    ])
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.scheduleTypeModel === _vm.SCHEDULE_TYPES.ONCE
              ? _c("brick-timer-schedule-once-settings", {
                  ref: "onceSettings",
                  attrs: {
                    date: _vm.singleRunConfiguration.date,
                    time: _vm.singleRunConfiguration.time
                  },
                  on: {
                    "update:date": function($event) {
                      return _vm.$set(
                        _vm.singleRunConfiguration,
                        "date",
                        $event
                      )
                    },
                    "update:time": function($event) {
                      return _vm.$set(
                        _vm.singleRunConfiguration,
                        "time",
                        $event
                      )
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.scheduleTypeModel === _vm.SCHEDULE_TYPES.RECURRING
              ? [
                  _c("brick-timer-frequency-settings", {
                    ref: "frequencySettings",
                    attrs: {
                      unit: _vm.frequencyConfiguration.unit,
                      "recurs-in-days": _vm.frequencyConfiguration.recursInDays,
                      weekdays: _vm.frequencyConfiguration.weekdays
                    },
                    on: {
                      "update:unit": function($event) {
                        return _vm.$set(
                          _vm.frequencyConfiguration,
                          "unit",
                          $event
                        )
                      },
                      "update:recursInDays": function($event) {
                        return _vm.$set(
                          _vm.frequencyConfiguration,
                          "recursInDays",
                          $event
                        )
                      },
                      "update:recurs-in-days": function($event) {
                        return _vm.$set(
                          _vm.frequencyConfiguration,
                          "recursInDays",
                          $event
                        )
                      },
                      "update:weekdays": function($event) {
                        return _vm.$set(
                          _vm.frequencyConfiguration,
                          "weekdays",
                          $event
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("brick-timer-daily-frequency-settings", {
                    ref: "dailyFrequencySettings",
                    attrs: {
                      frequency: _vm.dailyFrequencyConfiguration.frequency,
                      "recurrence-unit":
                        _vm.dailyFrequencyConfiguration.recurrenceUnit,
                      "recurs-in-seconds":
                        _vm.dailyFrequencyConfiguration.recursInSeconds,
                      "start-time": _vm.dailyFrequencyConfiguration.startTime,
                      "end-time": _vm.dailyFrequencyConfiguration.endTime
                    },
                    on: {
                      "update:frequency": function($event) {
                        return _vm.$set(
                          _vm.dailyFrequencyConfiguration,
                          "frequency",
                          $event
                        )
                      },
                      "update:recurrenceUnit": function($event) {
                        return _vm.$set(
                          _vm.dailyFrequencyConfiguration,
                          "recurrenceUnit",
                          $event
                        )
                      },
                      "update:recurrence-unit": function($event) {
                        return _vm.$set(
                          _vm.dailyFrequencyConfiguration,
                          "recurrenceUnit",
                          $event
                        )
                      },
                      "update:recursInSeconds": function($event) {
                        return _vm.$set(
                          _vm.dailyFrequencyConfiguration,
                          "recursInSeconds",
                          $event
                        )
                      },
                      "update:recurs-in-seconds": function($event) {
                        return _vm.$set(
                          _vm.dailyFrequencyConfiguration,
                          "recursInSeconds",
                          $event
                        )
                      },
                      "update:startTime": function($event) {
                        return _vm.$set(
                          _vm.dailyFrequencyConfiguration,
                          "startTime",
                          $event
                        )
                      },
                      "update:start-time": function($event) {
                        return _vm.$set(
                          _vm.dailyFrequencyConfiguration,
                          "startTime",
                          $event
                        )
                      },
                      "update:endTime": function($event) {
                        return _vm.$set(
                          _vm.dailyFrequencyConfiguration,
                          "endTime",
                          $event
                        )
                      },
                      "update:end-time": function($event) {
                        return _vm.$set(
                          _vm.dailyFrequencyConfiguration,
                          "endTime",
                          $event
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("brick-timer-duration-settings", {
                    ref: "durationSettings",
                    attrs: {
                      "end-date": _vm.durationConfiguration.endDate,
                      "start-date": _vm.durationConfiguration.startDate,
                      "is-perpetual": _vm.durationConfiguration.isPerpetual
                    },
                    on: {
                      "update:endDate": function($event) {
                        return _vm.$set(
                          _vm.durationConfiguration,
                          "endDate",
                          $event
                        )
                      },
                      "update:end-date": function($event) {
                        return _vm.$set(
                          _vm.durationConfiguration,
                          "endDate",
                          $event
                        )
                      },
                      "update:startDate": function($event) {
                        return _vm.$set(
                          _vm.durationConfiguration,
                          "startDate",
                          $event
                        )
                      },
                      "update:start-date": function($event) {
                        return _vm.$set(
                          _vm.durationConfiguration,
                          "startDate",
                          $event
                        )
                      },
                      "update:isPerpetual": function($event) {
                        return _vm.$set(
                          _vm.durationConfiguration,
                          "isPerpetual",
                          $event
                        )
                      },
                      "update:is-perpetual": function($event) {
                        return _vm.$set(
                          _vm.durationConfiguration,
                          "isPerpetual",
                          $event
                        )
                      }
                    }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group" }, [
              _c("div", { staticClass: "col-12" }, [_c("hr")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("p", { domProps: { innerHTML: _vm._s(_vm.summary) } })
              ])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }